import React, { useState } from 'react';

export default function AdminStorageSection({ appId }) {
  const [expandedSections, setExpandedSections] = useState({
    cloudflare: false
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <span>💾</span>
          <span>Storage</span>
        </h2>
        <p className="text-sm text-gray-500 mt-1">
          Storage service configuration
        </p>
      </div>

      <div className="space-y-4">
        {/* Cloudflare R2 Configuration */}
        <div className="border border-gray-200 rounded-lg">
          <button
            onClick={() => toggleSection('cloudflare')}
            className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors"
          >
            <h4 className="text-sm font-semibold text-gray-900">Cloudflare R2</h4>
            <span className="text-gray-500 text-sm">
              {expandedSections.cloudflare ? '▼' : '▶'}
            </span>
          </button>
          {expandedSections.cloudflare && (
            <div className="p-4 pt-4 border-t border-gray-200 bg-gray-50">
              <div className="space-y-4 text-sm text-gray-700">
                <div>
                  <h5 className="font-semibold text-gray-900 mb-2">Cloudflare R2 Setup</h5>
                  <ol className="list-decimal list-inside space-y-3 text-gray-600">
                    <li>
                      <span className="font-medium text-gray-700">Access Cloudflare R2 Dashboard</span>
                      <p className="ml-5 mt-1 text-xs">
                        Cloudflare account ID: <span className="font-mono bg-gray-200 px-1 rounded">66ca0e824830547f97fbab26f797de1c</span>
                      </p>
                      <p className="ml-5 mt-1 text-xs">
                        Go to <a href="https://dash.cloudflare.com/66ca0e824830547f97fbab26f797de1c/r2/overview" target="_blank" rel="noopener noreferrer" className="text-zapt-purple hover:underline">https://dash.cloudflare.com/66ca0e824830547f97fbab26f797de1c/r2/overview</a>
                      </p>
                    </li>
                    <li>
                      <span className="font-medium text-gray-700">Create dev and prod buckets</span>
                      <p className="ml-5 mt-1 text-xs">Create two separate R2 buckets: one for development and one for production environments.</p>
                    </li>
                    <li>
                      <span className="font-medium text-gray-700">Create API keys for each bucket</span>
                      <p className="ml-5 mt-1 text-xs">Generate API tokens with read/write permissions for both the dev and prod buckets. Store these securely.</p>
                    </li>
                    <li>
                      <span className="font-medium text-gray-700">Add Cloudflare environment variables</span>
                      <p className="ml-5 mt-1 text-xs">Add the following environment variables to your app's configuration (typically in Vercel or your deployment platform):</p>
                      <div className="ml-5 mt-2 space-y-1">
                        <p className="text-xs font-mono bg-gray-200 px-2 py-1 rounded">CLOUDFLARE_R2_ACCOUNT_ID</p>
                        <p className="text-xs font-mono bg-gray-200 px-2 py-1 rounded">CLOUDFLARE_R2_ACCESS_KEY_ID</p>
                        <p className="text-xs font-mono bg-gray-200 px-2 py-1 rounded">CLOUDFLARE_R2_SECRET_ACCESS_KEY</p>
                        <p className="text-xs font-mono bg-gray-200 px-2 py-1 rounded">CLOUDFLARE_R2_BUCKET_NAME</p>
                        <p className="text-xs font-mono bg-gray-200 px-2 py-1 rounded">CLOUDFLARE_R2_ENDPOINT</p>
                      </div>
                      <p className="ml-5 mt-2 text-xs text-gray-500">
                        Note: Use different bucket names and API keys for dev and prod environments. The endpoint is typically <span className="font-mono bg-gray-200 px-1 rounded">https://{'{account-id}'}.r2.cloudflarestorage.com</span>
                      </p>
                    </li>
                  </ol>
                </div>

                {/* Configure CORS */}
                <div className="pt-4 border-t border-gray-300">
                  <h5 className="font-semibold text-gray-900 mb-2">Configure CORS</h5>
                  <p className="text-xs text-gray-600 mb-3">
                    If the frontend uploads files directly to R2 using presigned PUT URLs, CORS must be enabled on the bucket.
                  </p>
                  <ol className="list-decimal list-inside space-y-2 text-xs text-gray-600">
                    <li>
                      Go to your bucket → <span className="font-semibold text-gray-700">Settings</span> → <span className="font-semibold text-gray-700">CORS Policy</span>
                    </li>
                    <li>
                      Add the following rule:
                      <pre className="mt-2 ml-5 text-xs text-gray-800 font-mono bg-gray-50 px-3 py-3 rounded border border-gray-300 overflow-x-auto whitespace-pre-wrap">
{`[
  {
    "AllowedOrigins": ["https://your-app-domain.vercel.app"],
    "AllowedMethods": ["PUT"],
    "AllowedHeaders": ["Content-Type"],
    "MaxAgeSeconds": 3600
  }
]`}
                      </pre>
                    </li>
                  </ol>
                </div>

                <div>
                  <a
                    href="https://dash.cloudflare.com/66ca0e824830547f97fbab26f797de1c/r2/overview"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-white bg-zapt-purple rounded-lg hover:bg-zapt-purple/90 transition-colors"
                  >
                    Open Cloudflare R2 Dashboard →
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
